/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Tab_SubscriptionInputs */

const en_admin_payments_tab_subscription = /** @type {(inputs: Admin_Payments_Tab_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription`)
};

/**
* | output |
* | --- |
* | "Subscription" |
*
* @param {Admin_Payments_Tab_SubscriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_tab_subscription = /** @type {((inputs?: Admin_Payments_Tab_SubscriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Tab_SubscriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_tab_subscription(inputs)
});
export { admin_payments_tab_subscription as "admin.payments.tab_subscription" }